export default __webpack_public_path__ + "static/media/Vieos Image.7efc3002.png";